<template>
  <el-dialog 
    width="500px"
    :title="dialog.title" 
    :visible.sync="dialog.isShow"
    @open='open' 
    >
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="短信内容">
        <el-col :span="22">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="form.SmsTemplate">
          </el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="微信模板名称">
        <el-col :span="22">
          <el-input v-model="form.WxTemplateTitle" readonly="true"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="微信模板编号">
        <el-col :span="22">
          <el-input v-model="form.WxTemplateNo" readonly="true"></el-input>
        </el-col>
      </el-form-item>        
      <el-form-item label="微信模板Id">
        <el-col :span="22">
          <el-input v-model="form.WxTemplateId"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="发送方式">
        <el-select v-model="form.SendWay" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialog.isShow = false">取 消</el-button>
      <el-button type="primary" @click="Save">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
      dialog:{}
    },
    data (){
      return {
        form:{},
        options: [{
          value: 0,
          label: '不发送'
        },{
          value: 1,
          label: '发送微信消息'
        }, {
          value: 2,
          label: '发送短信消息'
        }, {
          value: 4,
          label: '同时发送微信短信'
        }],
      }
    },
    computed:{
    },
    mounted(){
    },
    methods:{     
      open:function(){      
        this.form = this.dialog.data
      },
      Save:function(){        
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/messageTemplate/Save',         
          data:that.form
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          } 
           that.dialog.isShow = false
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
